import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanySearcherComponent } from './components/company-searcher/company-searcher.component';
import {FormsModule} from "@angular/forms";
import { IconifyComponent } from './components/iconography/iconify/iconify.component';
import {LoadingIconComponent} from "./components/loaders/loading-icon/loading-icon.component";
import {SpinnerComponent} from "./components/loaders/spinner/spinner.component";



@NgModule({
  declarations: [
    CompanySearcherComponent,
    IconifyComponent,
    LoadingIconComponent,
    SpinnerComponent,
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    CompanySearcherComponent,
    IconifyComponent,
    LoadingIconComponent,
    SpinnerComponent,
  ]
})
export class SharedModule { }
